module.exports = __webpack_public_path__ + "static/media/calendar.ffc92a6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/calendar.svg
// module id = 243
// module chunks = 1